module.exports = __webpack_public_path__ + "media/vo-03-modal.ca5b92c9.mp3";